import { formatKpiValue, kpiOnTarget, type KpiDef } from "@/features/kpi/definitions";
import { periodLabel, type KpiEntry, type KpiPeriodType } from "@/features/kpi/repo";

function csvCell(value: string | number): string {
  const text = String(value);
  if (/[",\n\r]/.test(text)) return `"${text.replaceAll('"', '""')}"`;
  return text;
}

export function buildKpiCsv(
  definitions: KpiDef[],
  current: Map<string, KpiEntry>,
  previous: Map<string, KpiEntry>,
  periodType: KpiPeriodType,
  periodStart: string,
): string {
  const header = ["KPI", "Department", "Target", "Actual", "Previous", "Status", "Owner", "Period"];
  const period = periodLabel(periodStart, periodType);
  const rows = definitions.map((def) => {
    const entry = current.get(def.id);
    const prior = previous.get(def.id);
    const onTarget = entry ? kpiOnTarget(def, entry.value) : null;
    const status =
      !entry ? ""
      : onTarget === true ? "On target"
      : onTarget === false ? "Off target"
      : "Tracked";
    return [
      def.name,
      def.department,
      def.targetLabel,
      entry ? formatKpiValue(entry.value, def.unit) : "",
      prior ? formatKpiValue(prior.value, def.unit) : "",
      status,
      def.owner,
      period,
    ].map(csvCell).join(",");
  });
  return [header.join(","), ...rows].join("\n");
}

export function downloadKpiCsv(filename: string, csv: string): void {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
